import { useState, useEffect } from 'react';
import { useEasybase } from 'easybase-react';
import { Button, Card, CardContent, CardActions, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import KursEditDialog from './KursEditDialog';
import KursMitgliederDialog from './KursMitgliederDialog';
import { normalesDatum } from './ZeitFunktionen';

const Kursuebersicht = (props) => {
    const [kurse, setKurse] = useState([]);
    const { db, e } = useEasybase();

    const mounted = () => {
        console.log("mounted");
        db("KURS").return().where(e.eq('sr', props.sr)).limit(100).all()
            .then(kursListe => {
                db("BUCHUNG").return().where(e.eq('sr', props.sr)).limit(1000).all()
                    .then(buchungen => {
                        for (var k = 0; k < kursListe.length; k = k + 1) {
                            kursListe[k].belegt = 0;
                            kursListe[k].dabei = false;
                            kursListe[k].voll = '';
                        }
                        for (var b = 0; b < buchungen.length; b = b + 1) {
                            for (k = 0; k < kursListe.length; k = k + 1) {
                                if (kursListe[k]._key === buchungen[b].kursid) {
                                    ++kursListe[k].belegt;
                                    if (kursListe[k].belegt >= kursListe[k].max) {
                                        kursListe[k].voll = true;
                                    }
                                    if (buchungen[b].wer === props.wer) {
                                        kursListe[k].dabei = true;
                                    }
                                }
                            }
                        }
                        setKurse(kursListe);
                    });
            });
    };

    useEffect(() => {
        mounted();
        // eslint-disable-next-line
    }, []);

    const useStyles = makeStyles({
        ROT: {
            width: 300,
            background: 'lightgreen',
            color: 'black',
            borderRadius: 20,
            margin: 10,
            position: 'relative',
        },
        root: {
            width: 300,
            background: 'lightgrey',
            color: 'black',
            borderRadius: 20,
            margin: 10,
            position: 'relative',
        },
        bullet: {
            display: 'inline-block',
            margin: '0 2px',
            transform: 'scale(0.8)',
        },
        title: {
            fontSize: 14,
        },
        pos: {
            marginBottom: 12,
        },
    });
    const classes = useStyles();

    const onSetAktiv = async (event) => {
        console.log("SetAktiv:" + event.currentTarget.value);
        await db("BUCHUNG").insert({
            wer: props.wer,
            kursid: "" + event.currentTarget.value,
            sr: props.sr
        }).one().then(insRes => {
            console.log("Insert liefert:" + insRes);
            mounted();
        });
    }

    const onResetAktiv = async (event) => {
        console.log("ResetAktiv:" + event.currentTarget.value);
        const delRes = await db("BUCHUNG").delete().where(
            e.and(
                e.eq('kursid', event.currentTarget.value),
                e.eq('wer', props.wer)
            )).all();
        console.log("Delete liefert:" + delRes);
        mounted();
    }

    const [edKursName, setEdKursName] = useState("");
    const [edKursDatum, setEdKursDatum] = useState("");
    const [edKursZeit, setEdKursZeit] = useState("");
    const [edKursMax, setEdKursMax] = useState(0);
    const [edKursAktiv, setEdKursAktiv] = useState(false);
    const [edKursBemerkung, setEdKursBemerkung] = useState("");
    const [edKursKey, setEdKursKey] = useState("");
    const [edKursOpen, setEdKursOpen] = useState(false);
    const [edMitgliederOpen, setEdMitgliederOpen] = useState(false);
    const onClickEditKurs = async (event) => {
        for (var i = 0; i < kurse.length; i = i + 1) {
            if (kurse[i]._key === event.currentTarget.value) {
                setEdKursName(kurse[i].name);
                setEdKursDatum(kurse[i].datum);
                setEdKursZeit(kurse[i].zeit);
                setEdKursMax(kurse[i].max);
                setEdKursAktiv(kurse[i].aktiv);
                setEdKursBemerkung(kurse[i].bemerkung);
                setEdKursKey(kurse[i]._key);
                setEdKursOpen(true);
            }
        }
    }

    const onKursExit = (erg) => {
        setEdKursOpen(false);
        if (erg) {
            mounted();
        }
    }

    const onClickMitgliederKurs = async (event) => {
        for (var i = 0; i < kurse.length; i = i + 1) {
            if (kurse[i]._key === event.currentTarget.value) {
                setEdKursName(kurse[i].name);
                setEdKursDatum(kurse[i].datum);
                setEdKursZeit(kurse[i].zeit);
                setEdKursKey(kurse[i]._key);
                setEdMitgliederOpen(true);
            }
        }
    }

    const onMitgliederExit = (erg) => {
        setEdMitgliederOpen(false);
        if (erg) {
            mounted();
        }
    }

    return (
        <Grid style={{ padding: 16 }} container spacing={3}>
            <Grid item sm={12}>
                <Typography variant="body1">{props.wer}</Typography>
            </Grid>
            <Grid item sm={12}>
                <Typography variant="h4">Kurs&uuml;bersicht {props.sr === "s" ? "Sportarena" : "REHA"}:</Typography>
            </Grid>
            {kurse.map((kurs) => <Grid item sm={3}>
                <Card key={"" + kurs._key} className={kurs.dabei ? classes.ROT : classes.root}>
                    <CardContent>
                        <Typography key={kurs._key + ".n"} variant="body1">{kurs.name}</Typography>
                        <Typography key={kurs._key + ".d"} variant="body1">{normalesDatum(kurs.datum)} {kurs.zeit}</Typography>
                        <Typography key={kurs._key + ".b"} variant="body1">{kurs.belegt}/{kurs.max}, {kurs.voll ? "VOLL," : "NOCH_PLATZ,"} {kurs.dabei ? "schon_gebucht" : "--"}</Typography>
                        <Typography key={kurs._key + ".m"} variant="body1">{kurs.bemerkung}</Typography>
                    </CardContent>
                    <CardActions>
                        {kurs.dabei && kurs.aktiv && (<Button value={"" + kurs._key} variant="contained" onClick={onResetAktiv}>Ausbuchen</Button>)}
                        {!kurs.dabei && kurs.aktiv && !kurs.voll && (<Button value={"" + kurs._key} variant="contained" onClick={onSetAktiv}>Einbuchen</Button>)}
                        {props.adminRechte && (<Button value={"" + kurs._key} variant="contained" onClick={onClickEditKurs}>Bearbeiten</Button>)}
                        {edKursOpen && (<KursEditDialog fertig={onKursExit}
                            edName={edKursName}
                            edDatum={edKursDatum}
                            edZeit={edKursZeit}
                            edMax={edKursMax}
                            edAktiv={edKursAktiv}
                            edBemerkung={edKursBemerkung}
                            edKey={edKursKey} />)}
                        {props.adminRechte && (<Button value={"" + kurs._key} variant="contained" onClick={onClickMitgliederKurs}>Buchungen</Button>)}
                        {edMitgliederOpen && (<KursMitgliederDialog fertig={onMitgliederExit}
                            edName={edKursName}
                            edDatum={edKursDatum}
                            edZeit={edKursZeit}
                            edSr={props.sr}
                            edKey={edKursKey} />)}
                    </CardActions>
                </Card>
            </Grid>
            )}
        </Grid>
    );
};
export default Kursuebersicht;